<template>
    <div class="componentTextPersona">
        <i class="fa-solid fa-user-tie-hair"></i>
        <p class="title-text-persona">{{ $t('dash.reporting.section.demographie.subtitle.profil_type') }}</p>


        <div class="genre">
            <h3 v-if="stats.audience_gender[0].name == 'M'">{{ $t('dash.reporting.section.demographie.type_man') }}</h3>
            <h3 v-if="stats.audience_gender[0].name == 'F'">{{ $t('dash.reporting.section.demographie.type_female') }}</h3>
            <h3 v-if="stats.audience_gender[0].name == 'U'">{{ $t('dash.reporting.section.demographie.type_undefined') }}</h3>
            <i v-if="stats.audience_gender[0].name == 'M'" class="fa-solid fa-mars"></i>
            <i v-if="stats.audience_gender[0].name == 'F'" class="fa-solid fa-venus"></i>
        </div>

        <div class="age">
            <p>{{ $t('dash.reporting.section.demographie.aged') }}</p>
            <h3>{{ stats.profil_type_age }} {{ $t('dash.reporting.section.demographie.years') }}</h3>
        </div>
        <div class="country">
            <p>{{ $t('dash.reporting.section.demographie.from')}}</p>
            <h3>{{ getCountryName(stats.profil_type_country) }}</h3>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            stats: Object,
        },

        methods: {
            getCountryName(countryCode, language = 'fr') {
                const displayNames = new Intl.DisplayNames([language], { type: 'region' });
                return displayNames.of(countryCode.toUpperCase());
            }
        }
    }
</script>
